/**
 * Returns a new array with unique items based on the specified key.
 * @param array - The array to filter.
 * @param key - The key to determine uniqueness.
 * @returns - A new array with unique items.
 */
export function uniqBy<T>(array: T[], key: keyof T): T[] {
  const seen = new Set();
  return array.filter((item) => {
    const k = item[key];
    if (seen.has(k)) {
      return false;
    }
    seen.add(k);
    return true;
  });
}
